import { type SyncStorage } from 'jotai/vanilla/utils/atomWithStorage'

// Jotai atom with storage default serializes data, this makes it annoying to read strings so we can
// just create a custom storage function to store strings raw

export function createStringStorage<T extends string>(): SyncStorage<T> {
  return {
    getItem: (key, initialValue) =>
      (localStorage.getItem(key) as T | null) ?? initialValue,

    setItem: (key, value) => {
      localStorage.setItem(key, value)
    },

    removeItem: (key) => {
      localStorage.removeItem(key)
    }
  }
}
